import { CSSProperties, useRef, useState } from 'react';
import PhoneInput, { isValidPhoneNumber, DefaultInputComponentProps } from 'react-phone-number-input';

type MlxCountryPhoneInputProps = DefaultInputComponentProps & {
    onChange?: (value: string | undefined) => void;
};

const MlxCountryPhoneInput = (props: Readonly<MlxCountryPhoneInputProps>) => {
    let { className, style, id, ref, onChange, ...rest } = props;
    const phoneInputRef = useRef<any>(null);
    const [phoneInputFocused, setPhoneInputFocused] = useState(false);

    // Update class name
    if (!className) {
        className = '';
    }
    className += ` custom-country-phone ${phoneInputFocused ? 'focused' : ''}`;

    let customStyle: CSSProperties = style ? { ...style } : {};

    return (
        <PhoneInput
            className={className}
            style={customStyle}
            id={id}
            ref={phoneInputRef}
            defaultCountry="US"
            {...rest}
            onChange={(value) => (onChange ? onChange(value) : undefined)}
            onFocus={() => setPhoneInputFocused(true)}
            onBlur={() => {
                setPhoneInputFocused(false);
            }}
            international={false}
        />
    );
};

export default MlxCountryPhoneInput;
